export default __webpack_public_path__ + "static/media/github-brands.e2f07326.svg";